import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
const UserDashboardCardLoader: React.FC = () => <div className="p-4 sm:p-6 bg-white dark:bg-zinc-950/80 shadow-lg rounded-lg flex flex-row items-center space-x-4 border border-neutral-300 max-w-full sm:max-w-[500px]" data-sentry-component="UserDashboardCardLoader" data-sentry-source-file="user-card-loader.tsx">
    <Skeleton className="h-16 w-16 sm:h-20 sm:w-20 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="user-card-loader.tsx" />

    <div className="flex flex-col w-full space-y-2">
      <Skeleton className="h-5 w-3/4" data-sentry-element="Skeleton" data-sentry-source-file="user-card-loader.tsx" />
      <Skeleton className="h-4 w-1/2" data-sentry-element="Skeleton" data-sentry-source-file="user-card-loader.tsx" />
      <div className="flex items-center space-x-2">
        <Skeleton className="h-4 w-1/3" data-sentry-element="Skeleton" data-sentry-source-file="user-card-loader.tsx" />
        <Skeleton className="h-5 w-5 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="user-card-loader.tsx" />
      </div>
    </div>
  </div>;
export default UserDashboardCardLoader;